import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Ajv from 'ajv';

import env from 'configures';
import {
  LP_URL,
  INPUT_URL,
  CONF_URL,
  THANKS_URL,
  ADD_JOB_DESCRIPTION_URL,
  ADD_CONDITION_URL,
  ADD_INFO_URL,
  ADD_CONF_URL,
  ADD_THANKS_URL,
  ADD_SKILL_URL,
  ADD_ENVI_URL,
  PAGE_MAP,
  CHOICES_NAME_MAP,
  ERROR_MESSAGES,
  NO_NAME_ERROR_MESSAGES,
  CUSTOM_ERROR_MESSAGES,
  DROPDOWN_INITIAL_ITEM,
  CHOICES_MAP,
  FATAL_ERROR,
  MOVE_CONF_MSG,
  COMMENT_MAP,
} from 'utils/constant';
import { checkEkiCode } from 'utils/api';
import Measure from 'utils/measure';

export const scrollTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const lockScroll = () => {
  document.body.style.overflow = "hidden";
};

export const unLockScroll = () => {
  document.body.style.overflow = "auto";
};

export const isFatalApiError = (e) => {
  if(e.message === FATAL_ERROR) return true;
  if(e.message === 'Network Error') return true;
  if(e.response){
    if(e.response.status === 500) return true;
    if(e.response.status === 503) return true;
  }
  // console.log('isFatalApiError: safe: ', { e });
  return false;
};

// date型を文字列に変換
export const changeStr = (date) => {
  if(!date) return '';

  const yearStr = date.getFullYear();
  let monthStr = 1 + date.getMonth();
  let dayStr = date.getDate();
    
  monthStr = (`0${ monthStr}`).slice(-2);
  dayStr = (`0${ dayStr}`).slice(-2);
    
  let formatStr = 'YYYY/MM/DD';
  formatStr = formatStr.replace(/YYYY/g, yearStr);
  formatStr = formatStr.replace(/MM/g, monthStr);
  formatStr = formatStr.replace(/DD/g, dayStr);
  return formatStr;
};

// 選択肢名と値を渡すと、ラベルを返却
export const getChoiceLabel = (choiceName, value) => {
  if(!value) return '';

  const choices = CHOICES_MAP[choiceName];
  const target = choices.filter(choice => choice.value === value )[0];
  return target ? target.label : '';
};
// 選択肢名とパターンを渡すと、ラベルを返却
export const getChoicePatternLabel = (choiceName, pattern) => {
  if(!pattern) return '';

  const choices = CHOICES_MAP[choiceName];
  const target = choices.filter(choice => choice.pattern === pattern )[0];
  return target ? target.label : '';
};

// 選択肢名を渡すと、取りうる値を返却
export const getChoiceValues = (choiceName) => {
  const choices = CHOICES_MAP[choiceName];
  return choices.map(choice => choice.value);
};

// 半角数字10桁の乱数を生成
export const randomID = () =>{
  const min = 1000000000 ;
  const max = 9999999999 ;
  const result = Math.floor( Math.random() * (max + 1 - min) ) + min;
  return `${result}`;

};
// 入力チェックのスキーマ
const ajv = new Ajv({ allErrors: true });
// エラーオブジェクト
export class ErrorMessage {
  constructor(target, message, level = 9){
    this.target = target;
    this.message = message;
    this.level = level;
  }
}
// ドロップダウンの正規表現生成（完全一致）
const makeChoiceRegStr = (choiceName) => {
  // 初期値は空なので選択不可
  const okList = getChoiceValues(choiceName).filter(val => val !== DROPDOWN_INITIAL_ITEM.value);
  return `^(${okList.join('|')})$`;
};
// 先読み否定一致（1つでも含んでいたらNG）
const makeNotIncludeRegStr = (notIncludeList) => {
  return `^(?![\\s\\S]*(${notIncludeList.join('|')})).*`;
};
const PATTERN_MAP = {
  notIncludeRegStr: makeNotIncludeRegStr([ '<', '>', '\'', '"',
  '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳',
  'Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ',
  '㊤', '㊥', '㊦', '㊧', '㊨', '㍻', '㍼', '㍽', '㍾',
  '㎜', '㎝', '㎞', '℡', '№', '∮', '∑', '⊿', '∟', '㎡', '㈱', '㎎', '㏄', '㎏',
  '㌢', '㍉', '㌔', '㌧', '㍍', '㌃', '㌘', '㌶', '㌫', '㍑', '㍊', '㍗', '㌻', '㌍',
  '〝', '㌦', '〟', '㌣', '㏍', '㈲', '㈹',
  '纊', '褜', '鍈', '銈', '蓜', '俉', '炻', '昱', '棈', '鋹', '曻', '彅', '丨', '仡', '仼', '伀', '伃', '伹', '佖', '侒',
  '侊', '侚', '侔', '俍', '偀', '倢', '俿', '倞', '偆', '偰', '偂', '傔', '僴', '僘', '兊', '兤', '冝', '冾', '凬', '刕',
  '劜', '劦', '勀', '勛', '匀', '匇', '匤', '卲', '厓', '厲', '叝', '咜', '咊', '咩', '哿', '喆', '坙', '坥', '垬', '埈',
  '埇', '﨏', '塚', '增', '墲', '夋', '奓', '奛', '奝', '奣', '妤', '妺', '孖', '寀', '甯', '寘', '寬', '尞', '岦', '岺',
  '峵', '崧', '嵓', '﨑', '嵂', '嵭', '嶸', '嶹', '巐', '弡', '弴', '彧', '德', '忞', '恝', '悅', '悊', '惞', '惕', '愠',
  '惲', '愑', '愷', '愰', '憘', '戓', '抦', '揵', '摠', '撝', '擎', '敎', '昀', '昕', '昻', '昉', '昮', '昞', '昤', '晥',
  '晗', '晙', '晴', '晳', '暙', '暠', '暲', '暿', '曺', '朎', '朗', '杦', '枻', '桒', '柀', '栁', '桄', '棏', '﨓', '楨',
  '﨔', '榘', '槢', '樰', '橫', '橆', '橳', '橾', '櫢', '櫤', '毖', '氿', '汜', '沆', '汯', '泚', '洄', '涇', '浯', '涖',
  '涬', '淏', '淸', '淲', '淼', '渹', '湜', '渧', '渼', '溿', '澈', '澵', '濵', '瀅', '瀇', '瀨', '炅', '炫', '焏', '焄',
  '煜', '煆', '煇', '凞', '燁', '燾', '犱', '犾', '猤', '猪', '獷', '玽', '珉', '珖', '珣', '珒', '琇', '珵', '琦', '琪',
  '琩', '琮', '瑢', '璉', '璟', '甁', '畯', '皂', '皜', '皞', '皛', '皦', '益', '睆', '劯', '砡', '硎', '硤', '硺', '礰',
  '礼', '神', '祥', '禔', '福', '禛', '竑', '竧', '靖', '竫', '箞', '精', '絈', '絜', '綷', '綠', '緖', '繒', '罇', '羡',
  '羽', '茁', '荢', '荿', '菇', '菶', '葈', '蒴', '蕓', '蕙', '蕫', '﨟', '薰', '蘒', '﨡', '蠇', '裵', '訒', '訷', '詹',
  '誧', '誾', '諟', '諸', '諶', '譓', '譿', '賰', '賴', '贒', '赶', '﨣', '軏', '﨤', '逸', '遧', '郞', '都', '鄕', '鄧',
  '釚', '釗', '釞', '釭', '釮', '釤', '釥', '鈆', '鈐', '鈊', '鈺', '鉀', '鈼', '鉎', '鉙', '鉑', '鈹', '鉧', '銧', '鉷',
  '鉸', '鋧', '鋗', '鋙', '鋐', '﨧', '鋕', '鋠', '鋓', '錥', '錡', '鋻', '﨨', '錞', '鋿', '錝', '錂', '鍰', '鍗', '鎤',
  '鏆', '鏞', '鏸', '鐱', '鑅', '鑈', '閒', '隆', '﨩', '隝', '隯', '霳', '霻', '靃', '靍', '靏', '靑', '靕', '顗', '顥',
  '飯', '飼', '餧', '館', '馞', '驎', '髙', '髜', '魵', '魲', '鮏', '鮱', '鮻', '鰀', '鵰', '鵫', '鶴', '鸙', '黑'
 ]),
};
// ajv の入力チェックルール
// https://github.com/ajv-validator/ajv/blob/master/docs/json-schema.md
const schemas = {
  // ページごとのajvの入力チェック
  [INPUT_URL]: {
    required: [ 'workCategory' ],
    properties: {
      workCategory: { type: 'string', pattern: makeChoiceRegStr('workCategoryList') },
      workCategoryOtherDetail: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [ 'workCategoryOtherDetail' ],
  },
  [`${INPUT_URL}:add-input`]: {
    properties: {
      bgdOfRecruitment: { type: 'string', pattern: makeChoiceRegStr('bgdOfRecruitmentList') },
      bgdOfRecruitmentCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
      desiredStartDateKubun: { type: 'string', pattern: makeChoiceRegStr('desiredStartDateKubunList') },
      workPeriod: { type: 'string', pattern: makeChoiceRegStr('workPeriodList') },
    },
    allOf: [
      { if: { properties: { 'bgdOfRecruitment': { const: COMMENT_MAP.bgdOfRecruitmentCmnt.value } } }, then: { properties: { 'bgdOfRecruitmentCmnt': { minLength: 1 } } } },
      { if: { properties: { 'bgdOfRecruitment': { const: COMMENT_MAP.bgdOfRecruitmentCmnt.value } } }, then: { properties: { 'bgdOfRecruitmentCmnt': { pattern: '\\S' } } } },
      { if: { properties: { 'desiredStartDateKubun': { const: '03' } } }, then: { properties: { 'desiredStartDate': { minLength: 1 } } } },
      { if: { properties: { 'workPeriod': { const: '01' } } }, then: { properties: { 'workPeriodDate': { minLength: 1 } } } },
    ],
    showErrorMessages: [ 'bgdOfRecruitmentCmnt' ],
  },
  [`${INPUT_URL}:-input`]: {
    properties: {
      workDetailText: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
      companyNameText: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      dept: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      chargePersonNameText: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      tel: { type: 'string', pattern: '^([0-9-]{10,13})$', minLength: 1 },
      email: { type: 'string', pattern: '[\\w\\-._]+@[\\w\\-._]+\\.[A-Za-z]+', minLength: 1 },
      address: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      ekiCd: { type: 'string', pattern: '^[0-9]{5}$' },
      ekiName: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [ 'workDetailText', 'companyNameText', 'dept', 'chargePersonNameText', 'tel', 'email', 'address', 'ekiName' ],

  },
  [CONF_URL]: {
    properties: {
    },
    showErrorMessages: [
    ],
  },
  [ADD_JOB_DESCRIPTION_URL]: {
    required: [ 'duty', 'workInfoContent' ],
    properties: {
      duty: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('dutyList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
      dutyCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
      workInfoContent: { type: 'array', minItems: 1, uniqueItems: true},
      workInfoContentCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [ 
      'duty',
      'dutyCmnt',
      'workInfoContent',
      'workInfoContentCmnt',
    ],
  },
  [ADD_CONDITION_URL]: {
    required: [
      'ekiCd',
      'ekiName',
      'hourSalaryMax',
    ],
    properties: {
      ekiCd: { type: 'string', pattern: '^[0-9]{5}$' },
      ekiName: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      startTime: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
      endTime: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
      startTimeRangeStart: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      startTimeRangeEnd: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      endTimeRangeStart: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      endTimeRangeEnd: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      overTimeRange: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
      workingDayRangeOthers: { type: 'boolean' },
      workingDayCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
      attendance: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('attendanceList'),
        },
      },
      hourSalaryMax: { type: 'integer', minimum: 1, maximum: 9999 },
    },
    allOf: [
      {
        if: { properties: { 'workingDayRangeOthers': { const: false } } }, then: {
          properties: {
            workingDayRange: {
              type: 'array',
              items: {
                type: 'string',
                minLength: 1,
                maxLength: 2,
              },
            },
          }
        }
      },
      { if: { properties: { 'workingDayRangeOthers': { const: true } } }, then: { properties: { 'workingDayCmnt': { minLength: 1 } } } },
      { if: { properties: { 'workingDayRangeOthers': { const: true } } }, then: { properties: { 'workingDayCmnt': { pattern: '\\S' } } } },
      { if: { properties: { 'attendance': { const: COMMENT_MAP.remoteWorkCount.value } } }, then: { properties: { 'remoteWorkCount': { pattern: makeChoiceRegStr('remoteWorkCountList') } } } },
    ],
    showErrorMessages: [ 
      'ekiName',
      'workingDayCmnt',
      'hourSalaryMax',
    ],
  },
  [ADD_INFO_URL]: {
    required: [ 'companyNameText', 'dept', 'chargePersonNameText', 'tel', 'email', 'address' ],
    properties: {
      companyNameText: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      dept: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      chargePersonNameText: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      tel: { type: 'string', pattern: '^([0-9-]{10,13})$', minLength: 1 },
      email: { type: 'string', pattern: '[\\w\\-._]+@[\\w\\-._]+\\.[A-Za-z]+', minLength: 1 },
      address: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      employmentPlacementDispatching: { type: 'boolean' },
    },
    showErrorMessages: [ 'companyNameText', 'dept', 'chargePersonNameText', 'tel', 'email', 'address' ],
  },
  // スキル入力
  [ADD_SKILL_URL]: {
    required: [ 'excelSkill' ],
    properties: {
      excelSkill: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('excelskillList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
      otherSkills: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('otherSkillsList'),
        },
        uniqueItems: true,
      },
      skillOtherCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [ 'skillOtherCmnt' ],
  },
  [ADD_ENVI_URL]: { // 職場環境
    required: [ 'welfare', 'ageRange', 'genderRange' ],
    properties: {
      welfare: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('welfareList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
      ageRange: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('ageList'),
          minLength: 2,
          maxLength: 2,
        },
      },
      genderRange: { type: 'string', pattern: makeChoiceRegStr('genderRangeList'), minLength: 1 },
      workEnvi: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('workEnviList'),
        },
        uniqueItems: true,
      },
      workEnviCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
      welfareCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    allOf: [
      { if: { properties: { 'isWelfareCmntTextAreaVisible': { const: true } } }, then: { properties: { 'welfareCmnt': { minLength: 1 } } } },
    ],
    showErrorMessages: [ 'workEnviCmnt', 'welfareCmnt', 'ageRange' ],
  },

  [`${ADD_CONF_URL}:modal-bgdOfRecruitmentCmnt`]: {
    properties: {
      _selectBgdOfRecruitmentCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    allOf: [
      { if: { properties: { '_selectBgdOfRecruitment': { const: COMMENT_MAP.bgdOfRecruitmentCmnt.value } } }, then: { properties: { '_selectBgdOfRecruitmentCmnt': { minLength: 1 } } } },
      { if: { properties: { '_selectBgdOfRecruitment': { const: COMMENT_MAP.bgdOfRecruitmentCmnt.value } } }, then: { properties: { '_selectBgdOfRecruitmentCmnt': { pattern: '\\S' } } } },
      { if: { properties: { '_selectBgdOfRecruitment': { const: COMMENT_MAP.bgdOfRecruitmentCmnt.value } } }, then: { properties: { '_selectBgdOfRecruitmentCmnt': { pattern: PATTERN_MAP.notIncludeRegStr } } } },
    ],
    showErrorMessages: [
      '_selectBgdOfRecruitmentCmnt',
    ],
  },
  [`${ADD_CONF_URL}:modal-duty`]: {
    properties: {
      _modalDuty: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('dutyList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
      _modalDutyCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalDutyCmnt',
    ],
  },
  [`${ADD_CONF_URL}:modal-workInfoContentCmnt`]: {
    properties: {
      _modalWICCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalWICCmnt',
    ],
  },
  [`${ADD_CONF_URL}:modal-excelSkill`]: {
    properties: {
      _modalExcelSkill: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('excelskillList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
    },
    showErrorMessages: [
      '_modalExcelSkill',
    ],
  },
  [`${ADD_CONF_URL}:modal-otherSkills`]: {
    properties: {
      _modalOtherSkill: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('otherSkillsList'),
        },
        uniqueItems: true,
      },
    },
    showErrorMessages: [
      '_modalOtherSkill',
    ],
  },
  [`${ADD_CONF_URL}:modal-skillOtherCmnt`]: {
    properties: {
      _modalSkillOtherCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalSkillOtherCmnt',
    ],
  },
  [`${ADD_CONF_URL}:modal-ekiName`]: {
    properties: {
      _modalEkiCd: { type: 'string', pattern: '^[0-9]{5}$' },
      _modalEkiName: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalEkiName',
    ],
  },
  [`${ADD_CONF_URL}:modal-workTime`]: {
    properties: {
      _modalStartTime: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
      _modalEndTime: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
    },
    showErrorMessages: [
      '_modalStartTime',
      '_modalEndTime'
    ],
  },
  [`${ADD_CONF_URL}:modal-startTimeRange`]: {
    properties: {
      _modalStartTimeRangeStart: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      _modalStartTimeRangeEnd: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
    },
    showErrorMessages: [
      '_modalStartTimeRangeStart',
      '_modalStartTimeRangeEnd'
    ],
  },
  [`${ADD_CONF_URL}:modal-endTimeRange`]: {
    properties: {
      _modalEndTimeRangeStart: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
      _modalEndTimeRangeEnd: {
        type: 'array',
        items: {
          type: 'string',
          maxLength: 2,
        },
      },
    },
    showErrorMessages: [
      '_modalEndTimeRangeStart',
      '_modalEndTimeRangeEnd'
    ],
  },
  [`${ADD_CONF_URL}:modal-overTime`]: {
    properties: {
      _modalOverTimeRange: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 2,
          maxLength: 2,
        },
      },
    },
    showErrorMessages: [
      '_modalOverTimeRange'
    ],
  },
  [`${ADD_CONF_URL}:modal-workDay`]: {
    properties: {
      _modalWorkingDayRangeOthers: { type: 'boolean' },
    },
    allOf: [
      {
        if: { properties: { '_modalWorkingDayRangeOthers': { const: false } } }, then: {
          properties: {
            _modalWorkingDay: {
              type: 'array',
              items: {
                type: 'string',
                minLength: 1,
                maxLength: 2,
              },
            },
          }
        }
      },
      { if: { properties: { '_modalWorkingDayRangeOthers': { const: true } } }, then: { properties: { '_modalWorkingDayCmnt': { minLength: 1, maxLength: 500 } } } },
      { if: { properties: { '_modalWorkingDayRangeOthers': { const: true } } }, then: { properties: { '_modalWorkingDayCmnt': { pattern: '\\S' } } } },
      { if: { properties: { '_modalWorkingDayRangeOthers': { const: true } } }, then: { properties: { '_modalWorkingDayCmnt': { pattern: PATTERN_MAP.notIncludeRegStr } } } },
    ],
    showErrorMessages: [
      '_modalWorkingDayCmnt'
    ],
  },
  [`${ADD_CONF_URL}:modal-attendance`]: {
    properties: {
      _modalAttendance: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('attendanceList'),
        },
      },
    },
    showErrorMessages: [
      '_modalAttendance',
      '_modalRemoteWorkCount'
    ],
  },

  [`${ADD_CONF_URL}:modal-hourSalary`]: {
    properties: {
      _modalSalaryMax: { type: 'string', minLength: 1, pattern: '^[0-9]{4}$' },
    },
    showErrorMessages: [
      '_modalSalaryMax',
    ],
  },
  [`${ADD_CONF_URL}:modal-welfare`]: {
    properties: {
      _modalWelfare: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('welfareList'),
        },
        minItems: 1,
        uniqueItems: true,
      },
      _modalWelfareCmnt: { type: 'string', maxLength: 500, minLength: 0, if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },
    },
    allOf: [
      { if: { properties: { '_modalWelfare': { contains: { const: '05' } } } }, then: { properties: { '_modalWelfareCmnt': { minLength: 1 } } } },
      { if: { properties: { '_modalWelfare': { contains: { const: '05' } } } }, then: { properties: { '_modalWelfareCmnt': { pattern: '\\S' } } } },
      { if: { properties: { '_modalWelfare': { contains: { const: '05' } } } }, then: { properties: { '_modalWelfareCmnt': { pattern: PATTERN_MAP.notIncludeRegStr } } } },
    ],
    showErrorMessages: [
      '_modalWelfare',
      '_modalWelfareCmnt'
    ],
  },
  [`${ADD_CONF_URL}:modal-workEnvi`]: {
    properties: {
      _modalWorkEnvi: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('workEnviList'),
        },
        uniqueItems: true,
      },
    },
    showErrorMessages: [
      '_modalWorkEnvi'
    ],
  },
  [`${ADD_CONF_URL}:modal-ageRange`]: {
    properties: {
      _modalAgeRange: {
        type: 'array',
        items: {
          type: 'string',
          pattern: makeChoiceRegStr('ageList'),
          minLength: 2,
          maxLength: 2,
        },
      },
    },
    showErrorMessages: [
      '_modalAgeRange'
    ],
  },
  [`${ADD_CONF_URL}:modal-genderRange`]: {
    properties: {
      _modalGenderRange: { type: 'string', pattern: makeChoiceRegStr('genderRangeList'), minLength: 1 },
    },
    showErrorMessages: [
      '_modalGenderRange'
    ],
  },
  [`${ADD_CONF_URL}:modal-workEnviCmnt`]: {
    properties: {
      _modalWorkEnviCmnt: { type: 'string', maxLength: 500, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalWorkEnviCmnt',
    ],
  },
  [`${ADD_CONF_URL}:modal-companyNameText`]: {
    properties: {
      _modalCompanyNameText: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalCompanyNameText',
    ],
  },
  [`${ADD_CONF_URL}:modal-dept`]: {
    properties: {
      _modalDept: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalDept',
    ],
  },
  [`${ADD_CONF_URL}:modal-chargePersonNameText`]: {
    properties: {
      _modalChargePersonNameText: { type: 'string', maxLength: 150, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalChargePersonNameText',
    ],
  },
  [`${ADD_CONF_URL}:modal-tel`]: {
    properties: {
      _modalTel: { type: 'string', pattern: '^([0-9-]{10,13})$', minLength: 1 },
    },
    showErrorMessages: [
      '_modalTel',
    ],
  },
  [`${ADD_CONF_URL}:modal-email`]: {
    properties: {
      _modalEmail: { type: 'string', pattern: '[\\w\\-._]+@[\\w\\-._]+\\.[A-Za-z]+', minLength: 1 },
    },
    showErrorMessages: [
      '_modalEmail',
    ],
  },
  [`${ADD_CONF_URL}:modal-address`]: {
    properties: {
      _modalAddress: { type: 'string', maxLength: 300, minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
    },
    showErrorMessages: [
      '_modalAddress',
    ],
  },
  [`${ADD_CONF_URL}:modal-employmentPlacementDispatching`]: {
    employmentPlacementDispatching: { type: 'boolean' },
  },

  [ADD_CONF_URL]: {
    required: ['workInfoContent'],
    properties: {
      workInfoContent: { type: 'array', minItems: 1, uniqueItems: true},
      hourSalaryMin: { type: 'integer', minimum: 0, maximum: 9999 },
      hourSalaryMax: { type: 'integer', minimum: 1, maximum: 9999 },
      otherComment: { type: 'string', maxLength: 500, minLength: 0, if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },
    },
    allOf: [
      { if: { properties: { 'otherComment': { minLength: 1 } } }, then: { properties: { 'otherComment': { pattern: '\\S' } } } },
    ],
    showErrorMessages: [
      'otherComment',
    ],
  },

  // Post時に変換するパラメータのみ追加チェック
  [`${ADD_CONF_URL}:post`]: {
    required: [],
    properties: {
      // state項目チェック
      bgdOfRecruitment: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      desiredStartDate: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      strWorkPeriod: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      workCategory: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      strWorkInfo: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      excelSkill: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      strOtherSkill: { type: 'string', if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },

      ekiCd: { type: 'string', pattern: '^[0-9]{5}$' },
      ekiName: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      strWorkTime: { type: 'string', if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },
      overtimeHoursMin: { type: 'integer', minimum: 0, maximum: 30 },
      overtimeHoursMax: { type: 'integer', minimum: 0, maximum: 30 },

      strDayOfTheWeek: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      WorkingConditions: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      hourSalaryMin: { type: 'integer', minimum: 0, maximum: 9999 },
      hourSalaryMax: { type: 'integer', minimum: 0, maximum: 9999 },
      welfare: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      workEnvi: { type: 'string', if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },
      ageRange: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      genderRange: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      workEnviCmnt: { type: 'string', if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },

      companyNameText: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      dept: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      chargePersonNameText: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      tel: { type: 'string', pattern: '^([0-9-]{10,13})$', minLength: 1 },
      email: { type: 'string', pattern: '[\\w\\-._]+@[\\w\\-._]+\\.[A-Za-z]+', minLength: 1 },
      address: { type: 'string', minLength: 1, pattern: PATTERN_MAP.notIncludeRegStr },
      employmentPlacementDispatching: { type: 'boolean' },

      otherComment: { type: 'string', maxLength: 500, minLength: 0, if: { maxLength: 0 }, else: { pattern: PATTERN_MAP.notIncludeRegStr } },
    },
    showErrorMessages: [
      'otherComment',
    ],
  },
};

// ajv 以外の相関チェック、APIを利用したチェックなど
const customChecks = { 
  // 対象駅判定
  checkEkiCode: async ({ ekiCd }) => {
    const target = 'ekiCd';
    const ok = null ;
    const ng = new ErrorMessage(target, CUSTOM_ERROR_MESSAGES.checkEkiCodeNG, 1);

    if( !ekiCd || ekiCd === '') return ok;

    const valid = await checkEkiCode({ ekiCd })
      .catch(err => {
        // console.log('checkEkiCode: catch');
        if(err.response.status === 400)return false;
        throw err;
      });
    return valid ? ok : ng;
  },
  // 就業開始日日付指定
  checkDesiredStartDate: async ({ desiredStartDate, desiredStartDateKubun }) => {
    const target = 'desiredStartDate';
    const ok = null ;
    const ng = new ErrorMessage(target, CUSTOM_ERROR_MESSAGES.checkDesiredStartDateNG, 1);

    // 正規表現パターン（半角英数４桁に一致）
    const regex = new RegExp(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/);
     
    // 判定
    if(desiredStartDateKubun === '03'){
      if (regex.test(desiredStartDate)) {
        return ok;
      } 
      return ng;
    } 
    return ok;
    
  },
  // 就業予定期間日付指定
  checkwWorkPeriodDate: async ({ workPeriodDate, workPeriod }) => {
    const target = 'workPeriodDate';
    const ok = null ;
    const ng = new ErrorMessage(target, CUSTOM_ERROR_MESSAGES.checkWorkPeriodDateNG, 1);

    // 正規表現パターン（半角英数４桁に一致）
    const regex = new RegExp(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/);
     
    // 判定
    if(workPeriod === '01'){
      if (regex.test(workPeriodDate)) {
        return ok;
      } 
      return ng;
    } 
    return ok;
    
  },
  // 最大 - 最小 > 9 エラー
  checkOverNine: async ({ target, min, max }) => {
    const ok = null ;
    const ng = new ErrorMessage(target, '実働が8時間以内になるように入力してください', 1);
    
    // 正規表現パターン（半角数字４桁に一致）
    const regex = new RegExp('^[0-9]{4}$');
     
    // いずれか未入力はOK
    if (!regex.test(min) || !regex.test(max)) {
      return ok;
    } 

    // 計算用に値セット
    const calcMin = min;
    let calcMax = max;

    // max<minの場合
    if(max < min ){
      calcMax = parseFloat(max) + 2400;
    }
    // 最大 - 最小 > 9 エラーチェック
    const valid = (parseFloat(calcMax) - parseFloat(calcMin)) <= 900;
    if(!valid) return ng;

    return ok;
  },
  // 最大 = 最小 エラー
  checkEqual: async ({ target, min, max }) => {
    const ok = null ;

    const name = CHOICES_NAME_MAP[target];
    const ng = new ErrorMessage(target, `${name}の入力内容が不正です`, 1);

    // 正規表現パターン（半角数字４桁に一致）
    const regex = new RegExp('^[0-9]{4}$');
     
    // いずれか未入力はOK
    if (!regex.test(min) || !regex.test(max)) {
      return ok;
    }
    
    // 最大 = 最小 エラーチェック
    const result = parseFloat(max) - parseFloat(min);
    if(result === 0){
      return ng;
    };

    return ok;
  },
  // 最大 - 最小 < 0
  checkLessThanZero: async ({ target, min, max }) => {
    const ok = null ;

    const name = CHOICES_NAME_MAP[target];
    const ng = new ErrorMessage(target, `${name}の入力内容が不正です`, 1);

    // いずれか未入力はOK
    if(!min || !max) return ok;

    const valid = (parseFloat(max) - parseFloat(min)) >= 0;
    if(!valid){
      // 請求金額の時エラーメッセージを変更
      if(target === 'hourSalaryMax' || target === '_modalSalaryMax'){
        const ngHourSalaryMax = new ErrorMessage(target, '下限以上の金額を入力してください', 1);
        return ngHourSalaryMax;
      }
      return ng;
    }
    return ok;
  },
  // テレワークの頻度 相関チェック
  checkRemoteWorkCount: async ({ attendance, remoteWorkCount }) => {
    const target = 'remoteWorkCount';
    const ok = null;
    const ng = new ErrorMessage(target, CUSTOM_ERROR_MESSAGES.remoteWorkCountNG, 1);
    if (attendance.includes('03')) {
      if (!remoteWorkCount.length) {
        return ng;
      }
    }
    return ok;
  },
};

// エラーをレベルでソート(0: 最優先)
export const sortErrors = (errors) => {
  errors.sort((a, b) => {
    if ( a.level === b.level ) { return 0; }
    return a.level < b.level ? -1 : 1;
  });
  return errors;
};

// 各画面でのvalidation
// カスタムチェック
export const isCustomValid = async ({ checks: checkFuncNames, target }) => {

  // カスタムエラーチェック
  const errorResult = await Promise.all(
    checkFuncNames.map(async (name) => {
      const ret = await customChecks[name]({ ...target })
        .catch(err => {
          // console.log('customChecks');
          throw err;
        });

      return ret ? {
        ...ret,
        custom: true,
      } : null;
    }),
  ).catch(err => {
    // console.log('Promise.all');
    throw err;
  });
  const customErrorMessages = errorResult.filter(x => !!x);
  const customErrorValid = customErrorMessages.length === 0;
  
  // エラーを返却
  return [
    customErrorValid,
    customErrorMessages,
  ];
};
// schema による静的チェック
export const isSchemaValid = ({ path = window.location.pathname, target }) => {

  // チェックルールを取得
  const schema = schemas[path];
  if(!schema) return [ true, [] ];

  // ajvによるチェック
  const validate = ajv.compile(schema);
  const valid = validate(target);
  // ajvによるエラー
  const errors = validate.errors ? validate.errors : [];
  const errorMessages = errors
    .map(error => {
      const dataPath = error.dataPath.replace(/^\./, '');
      const ok = null;
      // エラーメッセージ表示対象のみ表示
      if(!schema.showErrorMessages.includes(dataPath)) {
        return ok;
      }

      // エラーメッセージが存在するエラーのみ表示
      const message = ERROR_MESSAGES.filter(e => {
        if (error.keyword === "pattern" && error.params.pattern === PATTERN_MAP.notIncludeRegStr) {
          error.message = error.message.replace("should match pattern", "xss error");
        }
        return !!error.message.match(e.pattern);
      })[0];
      if(message.length === 0) {
        return ok;
      }

      // エラーメッセージを返却
      if (NO_NAME_ERROR_MESSAGES.includes(message.label)) {
        return new ErrorMessage(dataPath, `${message.label}`, 0);
      } else {
        const name = CHOICES_NAME_MAP[dataPath];
        return new ErrorMessage(dataPath, `${name}${message.label}`, 0);
      }
    }).filter(x => !!x);
  
  // NGの場合のコンソール表示
  if(!valid){
    // console.log(
    //   '%c[DEFAULT VALIDATE_ERROR]',
    //   'color:blue;',
    // );
    // console.log({
    //   path,
    //   target,
    //   schema,
    //   valid,
    //   validate,
    //   erros: errorMessages,
    // });
  }

  // エラーを返却
  return [
    valid,
    errorMessages,
  ];
};

// Web計測を実施
export const useAnalytics = () => {
  const isAnalytics = env.IS_ANALYTICS;
  const location = useLocation();

  useEffect(()=>{
    if( !isAnalytics ) return;
    
    switch(location.pathname){
      case INPUT_URL:
        Measure({
          pageName: 'sol:clcd:odform:input:index.html',
          title: '派遣依頼フォーム',
        }, false);
        break;
      case CONF_URL:
        Measure({
          pageName: 'sol:clcd:odform:conf:index.html',
          title: '派遣依頼確認画面',
        }, false);
        break;
      case THANKS_URL:
        Measure({
          pageName: 'sol:clcd:odform:thanks:index.html',
          title: '派遣依頼完了画面',
        }, false);
        break;
      case ADD_JOB_DESCRIPTION_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddJobDescription:index.html',
          title: '職種・業務内容画面',
        }, false);
        break;
      case ADD_SKILL_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddSkill:index.html',
          title: '業務に用いるスキル画面',
        }, false);
        break;
      case ADD_CONDITION_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddCondition:index.html',
          title: '就業条件画面',
        }, false);
        break;
      case ADD_ENVI_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddEnvi:index.html',
          title: '職場環境画面',
        }, false);
        break;
      case ADD_INFO_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddInfo:index.html',
          title: '基本情報画面',
        }, false);
        break;
      case ADD_CONF_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddConf:index.html',
          title: 'オンライン発注確認画面',
        }, false);
        break;
      case ADD_THANKS_URL:
        Measure({
          pageName: 'sol:clcd:odform:AddThanks:index.html',
          title: 'オンライン発注完了画面',
        }, false);
        break;
      default:
        break;
    }
  }, [ isAnalytics, location.pathname ] );
};

// 直接遷移を確認
export const useDirectTransCheck = ({ state }) => {
  const path = window.location.pathname;
  const { prevUrl } = PAGE_MAP[path];
  const { validMap } = state;

  const redirectUrl = env.ENV === 'local' ? INPUT_URL : LP_URL;

  useEffect(()=> {
    if(prevUrl && !validMap[prevUrl]){
      // console.log('[REDIRECT] useDirectTransCheck');
      window.location.href = redirectUrl;
    } 
  }, [ prevUrl, redirectUrl, validMap ]);
};
 
// window 幅、高さを取得
export const useWindowDimensions = () => {
 
  const getWindowDimensions = () => {
    const {
      innerHeight: height,
    } = window;
    const {
      offsetWidth: width,
    } = window.document.body;

    return {
      width,
      height,
    };
  };
 
  const [ windowDimensions, setWindowDimensions ] = useState(getWindowDimensions());
  useEffect(() => {
    const onResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return windowDimensions;
};
// UAがIEかどうか判定
export const useIECheck = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIE = userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1;
  return isIE;
};

// 画面遷移確認ダイアログ
export const MoveCheckMsg = (e) => {
  e.preventDefault();
  e.returnValue = MOVE_CONF_MSG;
};
export const MoveCheckStart = () => {
  window.addEventListener('beforeunload', MoveCheckMsg);
};
export const MoveCheckStop = () => {
  window.removeEventListener('beforeunload', MoveCheckMsg);
};

export const postHeightToParent = (origin, contHeight) => {
  const stage = process.env.REACT_APP_STAGE || 'local';
  const path = window.location.pathname;
  let postPrigin = '*';
  if(stage === 'main' || stage === 'staging'){
    postPrigin = origin;
  }
  window.parent.postMessage({ action: 'adjustHeight', height: contHeight }, postPrigin);
  if(path !== INPUT_URL){
    window.parent.postMessage({ action: 'scrollTo', scrollTarget: '.p-form' }, postPrigin);
  }
};

export const getCookies = (key) => {
  const cookie = document.cookie.match(`(^|;)\\s*${ key }\\s*=\\s*([^;]+)`);
  return cookie ? cookie.pop() : '';
};

export const groupByKey = (arr, prop) => {
  return arr.reduce(function (acc, obj) {
    const key = obj[prop];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};

// Enterでサブミットさせないようにする
export const onKeyDownFunc = (e) => {
  if(e.keyCode === 13){
    e.preventDefault();
    return false;
  }
  return true;
};